import '@js-joda/timezone';
import { DateTimeFormatter, Instant, LocalDate, LocalTime, ZoneId } from "@js-joda/core";
import { Locale } from "@js-joda/locale_en-us";

export const zoned                    = ( inst: Instant, zoneId: ZoneId = ZoneId.systemDefault() ) => inst.atZone( zoneId );
export const showInstant              = ( inst: Instant, zone: string ) => zoned( inst, ZoneId.of( zone ) ).format( usDateTime );
export const showInstantLocalDate     = ( inst: Instant ) => zoned( inst ).format( usDate     );
export const showInstantLocalDateTime = ( inst: Instant ) => zoned( inst ).format( usDateTime );
export const showInstantLocalTime     = ( inst: Instant ) => zoned( inst ).format( usTime     );
export const showInstantLocalDateTimeShort = ( inst: Instant ) => zoned( inst ).format( usDateShort1 );

const fmtr = DateTimeFormatter.ofPattern;
const usDate       = fmtr( "MM/dd/uuuu"         ).withLocale( Locale.US );
const usDateTime   = fmtr( "MM/dd/uuuu hh:mm a" ).withLocale( Locale.US );
const usTime       = fmtr( "hh:mm a"            ).withLocale( Locale.US );
const usDateShort0 = fmtr( "M/d/uu"             ).withLocale( Locale.US );
const usDateShort1 = fmtr( "MM/dd/uu"           ).withLocale( Locale.US );

//for much of our work, seconds and milliseconds will matter
const browserDate    = fmtr( "uuuu-MM-dd"        ).withLocale( Locale.US );
const browserTime    = fmtr( "HH:mm"             ).withLocale( Locale.US );
const browserTimeSec = fmtr( "HH:mm:ss"          ).withLocale( Locale.US );
const browserTimeMs  = fmtr( "HH:mm:ss.SSS"      ).withLocale( Locale.US );

//u year                | uu=26  uuuu=2026
//M month-of-year       | M=1-12 MM=01-12 MMM=Jan-Dec MMMM=January-December
//d day-of-month        | d=1-31 dd=01-31
//h clock-hour-of-am-pm | h=1-12 hh=01-12 
//H hour-of-day (0-23)  | H=0-23 HH=00-23
//m minute-of-hour      | m=0-59 mm=00-59
//s second-of-minute    | s=0-59 ss=00-59

//performance matters, so we pre-construct the formatters as globals
export function showBrowserDate   ( date: LocalDate ) { return browserDate.format( date ); }
export function showBrowserTime   ( time: LocalTime ) { return browserTime.format( time ); }
export function showBrowserTimeSec( time: LocalTime ) { return browserTimeSec.format( time ); }
export function showBrowserTimeMs ( time: LocalTime ) { return browserTimeMs.format( time ); }